import { Provider } from '@angular/core';

import { UserUseCasesImpl } from '@app/domain/use-cases/user/user.use-cases';
import { USER_USE_CASES } from '@app/domain/use-cases/user/user.use-cases.contract';

export const userUseCasesProvider: Provider = {
  provide: USER_USE_CASES,
  useClass: UserUseCasesImpl
};
